import { i18n } from '@/plugins/i18n'
import router from '@/router'
import { disconnectActionCable } from '@/services/actioncable.service'
import { clearAllStores } from '@/services/clear-stores'
import { useErrorStore } from '@/store/error'
import { useLoadingStore } from '@/store/loading'
import { useSessionStore } from '@/store/session'
import { useSuccessStore } from '@/store/success'
import axios from 'axios'

// Dev: sem credentials (CORS origins '*'). Staging/Prod: withCredentials para cookie do Cable.
const isDev = import.meta.env.DEV
const baseConfig = {
  baseURL: `${import.meta.env.VITE_API_URL}/api`,
  timeout: 600 * 1000,
  withCredentials: !isDev,
}

const axiosInstance = axios.create(baseConfig)

axiosInstance.interceptors.request.use((config) => {
  const newConfig = config
  const sessionStore = useSessionStore()
  const { initLoading } = useLoadingStore()

  newConfig.headers!['Access-Control-Allow-Origin'] = '*'

  if (config.headers && sessionStore.hasSession) {
    newConfig.headers!['Authorization'] = sessionStore.token
    newConfig.headers!['Cache-Control'] = 'no-cache'
  }

  return newConfig
})

axiosInstance.interceptors.response.use(
  (response) => {
    const message = response.data?.message

    if (message) {
      useSuccessStore().setSuccess([message])
    }

    return response
  },
  (error) => {
    const { removeLoading } = useLoadingStore()

    removeLoading()

    const { t } = i18n.global
    let errorMessages = error.response?.data?.errors || []

    if (typeof errorMessages === 'string') {
      errorMessages = [errorMessages]
    }

    if (error.response?.status) {
      switch (error.response.status) {
        case 401:
          disconnectActionCable()
          router.replace({ name: 'login' })
          useSessionStore().destroySession()
          clearAllStores()

          break
        case 500:
          errorMessages = [t('errors.server_error')]
          break
      }
    } else {
      errorMessages = [t('errors.network_error')]
    }

    useErrorStore().setErrors(errorMessages)

    return Promise.reject(error)
  },
)
export default axiosInstance
